export class CrescimentoDapIncompativelMessageStrategy {
	constructor(dapAnterior, dapAtual) {
		this.dapAnterior = dapAnterior
		this.dapAtual = dapAtual
	}

	get short() {
		return { message: 'Crescimento do DAP é incompatível' }
	}

	get long() {
		const message =
			this.dapAnterior > this.dapAtual
				? `O DAP coletado atual (${this.formattedCurrentDap}cm) é menor que o coletado no inventário anterior (${this.formattedPreviousDap}cm)`
				: `O DAP coletado atual (${this.formattedCurrentDap}cm) é maior que o coletado no inventário anterior (${this.formattedPreviousDap}cm)`
		const title =
			this.dapAnterior > this.dapAtual
				? 'DAP atual é menor que DAP do inventário anterior'
				: 'DAP atual é maior que DAP do inventário anterior'
		return { message, title }
	}

	get formattedPreviousDap() {
		return Number(this.dapAnterior).toFixed(2)
	}

	get formattedCurrentDap() {
		return Number(this.dapAtual).toFixed(2)
	}
}
